import React from 'react'
import {
  Row, Col, Switch, Select,
} from 'antd'

import __ from '../../languages/parser'

import {
  COLOR_URLS,
} from '../../static/url'

const { Option } = Select

const colors = {
  wood: ['black', 'white', 'oak', 'birch'],
  metal: ['black', 'white', 'brass'],
}

const SwatchOption = ({ color }) => (
  <Row>
    <Col span={4} style={{ textAlign: 'center' }}>
      <img src={COLOR_URLS[color]} alt={__(color)} style={{ height: '26px' }} />
    </Col>
    <Col span={20}>
      <span style={{ marginLeft: '1em', fontWeight: 600, textTransform: 'uppercase' }}>{__(color)}</span>
    </Col>
  </Row>
)

const SwatchContent = ({ color, type = 'metal', setColor }) => (
  <Row style={{ width: '100%' }}>
    <Select value={color} style={{ width: '100%' }} onChange={(evt) => { setColor(evt) }}>
      {colors[type].map((el) => <Option key={el}><SwatchOption color={el} /></Option>)}
    </Select>
  </Row>
)

const RecapMenu = ({
  setQuotes, isQuotes, metalColor, woodColor, setMetalColor, setWoodColor,
}) => {
  const handleQuotes = () => {
    setQuotes(!isQuotes)
  }
  return (
    <>
      <Row style={{ width: '100%', marginTop: '2em' }}>
        <span className="maker-subtitle" style={{ marginRight: '10px' }}>
          {__('Wall bases') }
          {' '}
          :
        </span>
        <SwatchContent color={metalColor} type="metal" setColor={setMetalColor} />
      </Row>
      <Row style={{ width: '100%' }}>
        <span className="maker-subtitle" style={{ marginRight: '10px', marginTop: '1em' }}>
          {__('Boards') }
          {' '}
          :
        </span>
        <SwatchContent color={woodColor} type="wood" setColor={setWoodColor} />
      </Row>

      <Row style={{ width: '100%', marginTop: '2em' }}>

        <Col span={4} style={{ textAlign: 'center' }}>
          <Switch
            onChange={() => { setQuotes(!isQuotes) }}
            defaultChecked={isQuotes}
            size="small"
            checked={isQuotes}
          />
        </Col>
        <Col span={20}>
          <div
            role="button"
            tabIndex="0"
            onKeyDown={handleQuotes}
            onClick={handleQuotes}
            style={{ cursor: 'pointer' }}
          >
            {__('Show dimensions')}
          </div>
        </Col>
      </Row>
    </>
  )
}

export default RecapMenu
